var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
let TubeMaterialSelection = class TubeMaterialSelection extends Vue {
    constructor() {
        super(...arguments);
        this.index = 0;
    }
    onChange(event) {
        this.index = event.target.selectedIndex;
        return this.materials[this.index].identifier;
    }
    initialize() {
        this.index = this.materials.findIndex(m => m.identifier === this.originalTubeMaterialId);
    }
    get materials() {
        return this.shopConfig.tubeMaterials.map(t => ({
            ...t,
            disabled: this.materialIds.every(id => id !== t.identifier),
        }));
    }
    get material() {
        return this.materials[this.index];
    }
    mounted() {
        this.initialize();
    }
    originalTubeMaterialIdChanged() {
        this.initialize();
    }
};
__decorate([
    Prop({ required: true })
], TubeMaterialSelection.prototype, "materialIds", void 0);
__decorate([
    Prop({ required: true })
], TubeMaterialSelection.prototype, "originalTubeMaterialId", void 0);
__decorate([
    Prop({ required: true })
], TubeMaterialSelection.prototype, "shopConfig", void 0);
__decorate([
    Emit()
], TubeMaterialSelection.prototype, "onChange", null);
__decorate([
    Inject()
], TubeMaterialSelection.prototype, "i18n", void 0);
__decorate([
    Watch("originalTubeMaterialId")
], TubeMaterialSelection.prototype, "originalTubeMaterialIdChanged", null);
TubeMaterialSelection = __decorate([
    Component({
        components: {},
        name: "TubeMaterialSelection",
    })
], TubeMaterialSelection);
export default TubeMaterialSelection;
